import { useSub } from "../subscription/useSub";
import type { AppRole } from "./navConfig";

export const useAppRole = (): AppRole => {
  const sub = useSub();
  if (sub.isSupplier) return "supplier";
  return sub.canCreateEvents ? "advisor" : "orderer";
};
